const Class = require('../../base/Class');
const g2 = require('../../g2');
const RenderUtil = require('../../utils/RenderUtil');
/**
 * @constructor
 * @classdesc 符号构建器
 * @alias G.utils.SymbolBuilder
 * @augments G.base.Class
 * @param {Object} options - 必填，构造参数
 * @returns {Object} 实例化对象
 */
const SymbolBuilder = Class.extend({
    options: {},
    initialize(options) {
        Class.setOptions(this, options);
        //
        let defautMarkerSymbol = {
            "type": "SimpleMarkerSymbol",
            "options": {
                "borderColor": {
                    "a": 200,
                    "r": 200,
                    "g": 200,
                    "b": 200
                },
                "fillColor": {
                    "a": 200,
                    "r": 0,
                    "g": 100,
                    "b": 255
                },
                "borderThickness": 1,
                "size": 4
            }
        }
        this.defaultSymbols = {
            Point: RenderUtil.object2Symbol(defautMarkerSymbol.type, defautMarkerSymbol.options),
            Polyline: g2.sfs.SimpleLineSymbol(),
            Polygon: g2.sfs.SimpleFillSymbol()
        }
    },
    /**
     * 构造符号
     * @method
     * @memberOf G.utils.SymbolBuilder.prototype
     * @param data {Object} 数据对象
     * @returns  {g2.sfs.Symbol}
     */
    build(data) {},
    destroy() {}
});

module.exports = SymbolBuilder;